/* eslint-disable jsx-a11y/anchor-is-valid */
import classnames from "classnames";
import PAText from "component/design-system/typography/PAText/PAText";
import Link from "next/link";
import PropTypes from "prop-types";
import { isTires } from "util/category/is-tires";
import { isWheels } from "util/category/is-wheels";
import { toLowerCase } from "util/lodash/toLowerCase";
import getCustomSizeQuery from "util/url/getCustomSizeQuery";
import { getHrefAndPath } from "util/url/getHrefAndPath";
import styles from "./breadcrumbV2.module.scss";

const propTypes = {
  title: PropTypes.string.isRequired,
};

export default function BreadcrumbItem(props: any) {
  const {
    className,
    title,
    onClick,
    style,
    url,
    isLast,
    showSeparator = false,
    categoryObj,
  } = props;

  const seprator = !isLast && showSeparator ? (
    <div className="m-l-5 m-r-5"> › </div>
  ) : <span />;

  const displayTitle = title?.replace(/parts|& parts/i, "");

  if (url && !onClick) {
    const customSizes = getCustomSizeQuery();
    const { href, asPath } = getHrefAndPath({ asPath: url, query: { ...customSizes } });
    let updatedHref = url; let
      updatedAsPath = url;
    if (customSizes && Object.keys(customSizes).length > 0 && (isTires(toLowerCase(categoryObj?.tier1)) || isWheels(toLowerCase(categoryObj?.tier1)))) {
      updatedHref = href;
      updatedAsPath = asPath;
    }

    return (
      <li
        className={classnames({
          "breadcrumb-item": true,
        }, className)}
        style={style}
      >

        <Link href={updatedHref} as={updatedAsPath} title={displayTitle}>

          <div className="title">
            {displayTitle}
          </div>
          {seprator}

        </Link>
      </li>
    );
  }

  return (
    <li
      className={classnames({
        [styles.disable_breadcrumb]: !url && !categoryObj,
        "breadcrumb-item": true,
      }, className)}
      style={style}
    >

      <>
        <a onClick={onClick}>
          <PAText component="div" className="title" title={displayTitle}>
            {displayTitle}
          </PAText>
          {seprator}
        </a>
      </>
    </li>
  );
}

BreadcrumbItem.propTypes = propTypes;
